import { createFileRoute, redirect } from '@tanstack/react-router';
import { AccountClosedScreen } from '@/features/onboarding/AccountClosedScreen';
import { gateRoute, sessionQuery } from '@/lib/session';

export const Route = createFileRoute('/account-closed')({
  // Mirrors the backend's DeclinedGate (bypass={declined} only): password,
  // tos and onboarding are all still enforced here. gateRoute() already
  // encodes that exact precedence, so anything other than this page itself
  // means the chef has something else to clear first (or, if gateRoute
  // returns null, nothing to show - legacy redirects a non-declined caller
  // away rather than rendering an empty page).
  beforeLoad: async ({ context }) => {
    const s = await context.queryClient.ensureQueryData(sessionQuery);
    if (!s.authenticated) throw redirect({ to: '/login' });
    const gate = gateRoute(s);
    if (gate !== '/account-closed') throw redirect({ to: gate ?? '/dashboard' });
  },
  component: AccountClosedScreen,
});
